/**
 * Created by lu on 2018/5/4.
 */
var nb = require('../../nb');
module.exports = nb.define({
    view:{
       'class':['pagination-list',nb.bind('dataReady')],
        style:{
           'min-height':'500px'
        },
        $html:[{
            tag:'img',
            'class':'loading-gif abs-center',
            src:'./image/loading.gif',
            style:{
                width:'70px'
            }
        },{
           'class':'list-scroll clearfix',
            $html:{
                'class':['clearfix',nb.bind('listItemStyle'),nb.bind('listName')],
                $type:nb.view.List,
                $model:'list'
            }
        },{
           'class':[nb.bind('paginationVisible')],
            $type:require('./Pagination'),
            $model:'pagination'
        }]
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/pagination/PaginationList.js
// module id = 54
// module chunks = 1 3 11 12 14 16 17 24 31 33